import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./style.css";
import { AiFillCaretRight } from "react-icons/ai";
import { FaCaretDown } from "react-icons/fa";

import img4 from "../../assets/images/four.jpg"
import { ConferenceTreeSlider } from "../../components/confereenceTreeSlider/ConferenceTreeSlider";
export const Conference = () => {
  const { t } = useTranslation();

  const [isFirstConferenceOpen, setIsFirstConferenceOpen] = useState(false);
  const [isSecondConferenceOpen, setIsSecondConferenceOpen] = useState(false);
  const [isFourthConferenceOpen, setIsFourthConferenceOpen] = useState(false);

  const day1 = t("conference1.schedule.day1", { returnObjects: true });
  const day2 = t("conference1.schedule.day2", { returnObjects: true });
  const day3 = t("conference2.part1.schedule", { returnObjects: true });
  const day4 = t("conference2.part2.schedule", { returnObjects: true });
  const history = t("conference4.history", { returnObjects: true }) || [];

  const conference4Part1 = t(
    "conference4.part1.schedule",
    { returnObjects: true }
  );

  const conference4Part2 = t(
    "conference4.part2.schedule",
    { returnObjects: true }
  );

  const toggleFirstConference = () => setIsFirstConferenceOpen(!isFirstConferenceOpen);
  const toggleSecondConference = () => setIsSecondConferenceOpen(!isSecondConferenceOpen);
  const toggleFourthConference = () => setIsFourthConferenceOpen(!isFourthConferenceOpen);
  return (
    <>
      <div className="activity-header">
        <h2>
          {t("navBar.home")} <span>/ {t("navBar.conference")}</span>
        </h2>
      </div>
      {/* 4th Conference */}

      <div className="conference">
        <h2
          onClick={toggleFourthConference}
          style={{ cursor: "pointer" }}
        >
          {t("conference4.title")}{" "}
          {isFourthConferenceOpen ? (
            <FaCaretDown />
          ) : (
            <AiFillCaretRight />
          )}
        </h2>

        {isFourthConferenceOpen && (
          <div className="conference-content">
            <p>{t("conference4.description1")}</p>

            <p>{t("conference4.description2")}</p>

            <p>{t("conference4.description3")}</p>

            <p>{t("conference4.description4")}</p>

            <p>
              <strong>
                {t("conference4.deadline")}
              </strong>
            </p>

            <p>
              {t("conference4.registrationText")}{" "}
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdbRI7CKoXd0djz4xdCgy0IQQJPkXdrde_anAD6CBkcTwQ5rQ/viewform"
                target="_blank"
                rel="noopener noreferrer"
                className="register-link"
              >
                🔗 {t("conference4.register")}
              </a>
            </p>

            <p>{t("conference4.paymentText")}</p>

            <h3>{t("conference4.part1.title")}</h3>

            <ul className="schedule">
              {conference4Part1.map((item, index) => (
                <li key={index}>
                  {item.time} — {item.event}

                  {item.speaker && (
                    <div className="speaker">
                      {item.speaker}
                    </div>
                  )}
                </li>
              ))}
            </ul>

            <h3>{t("conference4.part2.title")}</h3>

            <ul className="schedule">
              {conference4Part2.map((item, index) => (
                <li key={index}>
                  {item.time} — {item.event}

                  {item.speaker && (
                    <div className="speaker">
                      {item.speaker}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      {/* 3th Conference */}

      <div className="conference">
        <h2
          onClick={toggleFirstConference}
          style={{ cursor: "pointer" }}
        >
          {t("conference2.title")}{" "}
          {isFirstConferenceOpen ? (
            <FaCaretDown />
          ) : (
            <AiFillCaretRight />
          )}
        </h2>

        {isFirstConferenceOpen && (
          <div className="conference-content">

            {/* TEXT */}

            <div className="conference-highlight">

              {/* TEXT */}
              <div className="conference-description">
                <p>{t("conference2.finish.desc1")}</p>
                <p>{t("conference2.finish.desc2")}</p>
                <p>{t("conference2.finish.desc3")}</p>
                <p>{t("conference2.finish.desc4")}</p>
                <p>{t("conference2.finish.desc5")}</p>
                <p>{t("conference2.finish.desc6")}</p>
              </div>

              {/* SLIDER */}
              <div className="conference-slider-wrapper">
                <ConferenceTreeSlider />
              </div>

            </div>
            {/* OLD CONTENT */}

            <p>{t("conference2.description1")}</p>

            <p>
              {t("conference2.text")}
              <br />

              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfmLGZwtPG0vfnX4kQXzEK071T1F-Qt4eA9pvP0w1dzyk_LVg/viewform"
                target="_blank"
                rel="noopener noreferrer"
                className="register-link"
              >
                https://docs.google.com/...
              </a>
            </p>

            <h3>{t("conference2.part1.title")}</h3>

            <ul className="schedule">
              {day3.map((item, index) => (
                <li key={index}>
                  {item.time} - {item.event}

                  {item.speaker && (
                    <div className="speaker">
                      {item.speaker}
                    </div>
                  )}
                </li>
              ))}
            </ul>

            <h3>{t("conference2.part2.title")}</h3>

            <ul className="schedule">
              {day4.map((item, index) => (
                <li key={index}>
                  {item.time} - {item.event}

                  {item.speaker && (
                    <div className="speaker">
                      {item.speaker}
                    </div>
                  )}
                </li>
              ))}
            </ul>

          </div>
        )}
      </div>

      <div className="conference">
        <h2 onClick={toggleSecondConference} style={{ cursor: "pointer" }}>
          {t("conference1.title")} {isSecondConferenceOpen ? <FaCaretDown /> : <AiFillCaretRight />}
        </h2>
        {isSecondConferenceOpen && (
          <div className="conference-content">
            <p>{t("conference1.description1")}</p>

            <h3>{t("conference1.part1")}</h3>
            <ul className="schedule">
              {day1.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <h3>{t("conference1.part2")}</h3>
            <ul className="schedule">
              {day2.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </>
  );
};
